import { Grid, GridProps, Rating } from '@mui/material';
import { useField } from 'formik';
import React from 'react';

type SparkFormRatingProps = {
  name: string;
  size?: GridProps['xs'];
  gridProps?: GridProps;
  onChange?: (value: number | null) => void;
};

const SparkFormRating = ({
  name,
  size,
  gridProps = {},
  onChange,
}: SparkFormRatingProps) => {
  const fieldConfig = useField(name);
  const field = fieldConfig[0];
  const helper = fieldConfig[2];
  const handleChange = (value: number | null) => {
    helper.setValue(value);
    onChange && onChange(value);
  };
  return (
    <Grid item xs={size} container {...gridProps}>
      <Rating
        name='customized-color'
        value={field.value}
        precision={1}
        onChange={(_, value) => handleChange(value)}
        onBlur={() => helper.setTouched(true)}
        size='large'
        sx={{
          color: '#FFAC0C',

          '& .MuiRating-iconFilled': {
            color: '#FFAC0C',
          },
        }}
      />
    </Grid>
  );
};

export default SparkFormRating;
